import type { GQL_ID } from '@@partner:types:graphql'
import type { BrandInfo } from '@@partner:types:app'
import type { BrandInfoInput } from '@@partner:graphql/mutation/brand/updateCurrentBrandInfo.gql'
import type { BrandFile } from '@@partner:graphql/mutation/brand/setBrandFile.gql'

import { mergeLeft } from 'merge-left-utils'

export interface BrandInfoState extends BrandInfo {
  selectedDefaultShopId?: GQL_ID
  square_logo_id?: GQL_ID
  squareLogo?: { url?: string }
  appStyleConfig?: string
  brandFiles?: BrandFile[]
}

export const BRAND_DEFAULT_STATE: BrandInfoState = {
  id: undefined,
  name: '',
  logo_id: undefined,
  logo: { url: undefined },
  square_logo_id: undefined,
  squareLogo: { url: undefined },
  slug: '',
  primaryColorHex: '',
  primaryTextColorHex: '',
  appStyleConfig: '',
  brandFiles: [],
  defaultShop: {
    id: undefined
  },
  selectedDefaultShopId: undefined
}

export const makeBrandFormState = (brand?: BrandInfoState): BrandInfo => {
  return mergeLeft(BRAND_DEFAULT_STATE, {
    ...brand,
    selectedDefaultShopId: brand?.defaultShop?.id
      ? Number(brand?.defaultShop?.id)
      : undefined
  })
}

const BRAND_DEFAULT_INPUT: BrandInfoInput = {
  name: '',
  slug: '',
  default_shop_id: undefined,
  logo_id: undefined,
  square_logo_id: undefined,
  primaryColorHex: undefined,
  primaryTextColorHex: undefined,
  appStyleConfig: undefined
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (state: BrandInfoState): BrandInfoInput =>
  mergeLeft<BrandInfoInput>(BRAND_DEFAULT_INPUT, {
    ...state,
    logo_id: Number(state.logo_id),
    square_logo_id: state.square_logo_id ? Number(state.square_logo_id) : undefined,
    default_shop_id: state.defaultShop
      ? Number(state.selectedDefaultShopId)
      : undefined,
    appStyleConfig: state.appStyleConfig || undefined
  })

export const mapApiDataToState = (data: BrandInfo) => data
